import type { RemoveFromCartPayload } from "@model/Cart.model";
import { CART_REMOVE_ITEM } from "./CartActionTypes";

export const removeFromCartAction =
  (payload: RemoveFromCartPayload) =>
  (dispatch: any) => {
    dispatch({ type: CART_REMOVE_ITEM, payload });
  };
